

<div class="flex-container">
  <div style="position: sticky; top:0px; z-index: 80">
    <div class="d-flex align-items-center flex-row justify-content-end filter-bar">
      <div class="padding-datepicker datepicker-font">
        <mat-form-field appearance="outline">
          <input matInput #ref [matDatepicker]="picker" (ngModelChange)="onDateClicked($event)" [(ngModel)]="activeDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="ml-auto pointer">
        <img *ngIf="canEdit()" title="Lägg till schema" class="me-2" src="../assets/images/green-add.svg" (click)="onAddClick()" alt="Lägg till" />
        <img title="Importera från Heroma" class="me-2" src="../assets/images/export-heroma.svg" (click)="onImportFromHeromaClick()" alt="Importera från Heroma" />
      </div>
    </div>
  </div>
  <ngx-spinner #spinner [config]="spinnerConfig">
  </ngx-spinner>
  <mat-table #table [dataSource]="dataSource" matSort matSortDisableClear="true" class="mat-elevation-z0" *ngIf="dataSource">
    <mat-header-row style="background-color:white; position: sticky; z-index: 90;" *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"  [ngClass]="getRowClass(row)"></mat-row>

    <!-- Inloggad/Utloggad -->
    <ng-container matColumnDef="checked-in-status">
      <mat-header-cell *matHeaderCellDef>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span *ngIf="canEdit()">
          <img *ngIf="element.checkedin" src="../assets/images/fellow_green.svg" alt="Incheckad" />
          <img *ngIf="!element.checkedin && !element.lateToWork" src="../assets/images/fellow_red.svg" alt="Börjar snart" />
          <img class="blink" *ngIf="!element.checkedin && element.lateToWork" src="../assets/images/fellow_yellow.svg" alt="Ej incheckad" />
        </span>
        <span *ngIf="!canEdit()" matTooltip="Det går endast att editera poster för dagens datum">
          <img src="../assets/images/lock_red.svg" alt="Låst" />
        </span>
      </mat-cell>
    </ng-container>

    <!-- Uppdrag -->
    <ng-container matColumnDef="skill">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Uppdrag </mat-header-cell>
      <mat-cell *matCellDef="let element">{{getReadableSkill(element.skill)}}</mat-cell>
    </ng-container>

    <!-- Förare -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Förare </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
    </ng-container>

    <!-- Buss -->
    <ng-container matColumnDef="buss">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Buss </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-select class="quick-edit-select" [ngModel]="element.buss" (ngModelChange)="changeBus(element, $event)">
          <mat-option *ngFor="let bus of buses" [value]="bus.number">{{bus.number}}</mat-option>
        </mat-select>
      </mat-cell>
    </ng-container>

    <!-- Tid -->
    <ng-container matColumnDef="start">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Tid </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-select class="quick-edit-select" value="{{getTimeString(element.start)}}" (selectionChange)="changeStart(element, $event)">
          <mat-option *ngFor="let time of timeListFrom" [value]="time">{{time}}</mat-option>
        </mat-select>
        <span class="time-picker-divider"> - </span>
        <mat-select class="quick-edit-select" value="{{getTimeString(element.end)}}" (selectionChange)="changeEnd(element, $event)">
          <mat-option *ngFor="let time of timeListTo" [value]="time">{{time}}</mat-option>
        </mat-select>
      </mat-cell>
    </ng-container>

    <!-- Aktiviet -->
    <ng-container matColumnDef="activityName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Aktivitet </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.activityName}}</mat-cell>
    </ng-container>

    <!-- Anteckning -->
    <ng-container matColumnDef="comment">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Anteckning </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-form-field>
          <input type="text" matInput [(ngModel)]="element.comment" (input)="checkScheduleChanged(element)" />
        </mat-form-field>
      </mat-cell>

    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="canEdit() && hasScheduleChanges()" class="schedule-update-controller-container" (click)="undoChangedToAllSchedules()">
          <img title="Ångra förändringar" style="fill:red;" class="me-2" src="../assets/images/undo-icon.svg" alt="Undo" />
          <span class="undo-changes-text">Ångra alla</span>
        </div>
        <div *ngIf="canEdit() && hasScheduleChanges()" class="schedule-update-controller-container" (click)="onSaveSchedulesClick()">
          <img title="Spara förändringar" class="me-2" src="../assets/images/check-round-green.svg" alt="Spara" />
          <span class="save-changes-text">Spara alla</span>
        </div>


      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="row-controls row-edit-controls">
          <span *ngIf="canEdit() && rowHasChanges(element)">
            <button type="button" data-cy="undo" style="background-color:transparent; border:0px; float: right;" class="delete-button" (click)="undoChangesToRow(element)"><img src="../assets/images/undo-icon.svg" width="18" height="18" /></button>
          </span>
        </div>
        <div class="row-controls">
          <span *ngIf="canEdit()">
            <button type="button" data-cy="edit" style="background-color:transparent; border:0px;" class="delete-button" (click)="onRowClick(element)"><img src="../assets/images/edit-icon.svg" width="18" height="18" /></button>
          </span>
          <span *ngIf="canEdit()">
            <button type="button" data-cy="delete" style="background-color:transparent; border:0px;" class="delete-button" (click)="buttonDeleteCallback($event, element);"><img src="../assets/images/delete-icon.svg" width="18" height="18" /></button>
          </span>
        </div>


      </mat-cell>
    </ng-container>

  </mat-table>
</div>
